import React, { useEffect, useState } from 'react'
import styles from './LoginPage.module.css'
import { useNavigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { prpHttpAPI } from '../../services/prpHttpAPI';
const LoginPage = () => {
  const navigate = useNavigate();
  const checkToken = async (e) => {
    const localtoken = localStorage.getItem("ssotoken");
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const ssotoken = queryParams.get('ssotoken');
    if (localtoken) {
      console.log('User Already logged in');
      // console.log("admin",  jwtDecode(localtoken));
      console.log("admin local",  jwtDecode(localtoken)["custom:isAdmin"], jwtDecode(localtoken)["name"], jwtDecode(localtoken)["custom:BCode"]);
      const bCode = jwtDecode(localtoken)["custom:BCode"]
     // const isAdmin = jwtDecode(localtoken)["custom:isAdmin"]
      const userName = jwtDecode(localtoken)["name"]?jwtDecode(localtoken)["name"]: isAdmin==1 ? "ADMIN": "USER";
     // localStorage.setItem('isAdmin',isAdmin);
      localStorage.setItem('bCode', bCode);
      window.location.href = '/search';
    }
    else if (ssotoken) {
      console.log('Token found');
      localStorage.setItem("ssotoken", ssotoken);
//    
      const userData = {
        flagType:'default' };
      const result = await prpHttpAPI(userData, 'rm-info', ssotoken, "POST");
     
  
      if (result?.success) {
        console.log("rm data is:", result);
        localStorage.setItem('rmInfo', JSON.stringify(result.data[0]))

        if(result.data[0].CATEGORY_ID != '2018' && result.data[0].CATEGORY_ID != '2001'){
          console.log('you cannont make plan')
        }
        else{
          localStorage.setItem('payroll_id', result.data[0].EMP_PAYROLL_ID);
          console.log('you can make plan')
        }

        
         localStorage.setItem('isAdmin',result.isAdmin);
      } else {
        console.log("result in rm info", result);
      }

     // console.log("admin sso",  jwtDecode(ssotoken)["custom:isAdmin"],jwtDecode(ssotoken)["name"], jwtDecode(ssotoken)["custom:BCode"]);
      const bCode = jwtDecode(ssotoken)["custom:BCode"]
      // const isAdmin = jwtDecode(ssotoken)["custom:isAdmin"]
      const userName = jwtDecode(ssotoken)["name"]?jwtDecode(ssotoken)["name"]:"ADMIN";
     // localStorage.setItem('isAdmin',isAdmin);
      localStorage.setItem('bCode', bCode);

      window.location.href ='/search';
    }
    else {
      const actionType = queryParams.get('action');
      console.log('token not found', actionType);
      if (actionType) {
        window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}&action=${actionType}`;
      }
      else {
        window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;
      }
      // Redirect to a different URL


      //  navigate('');
    }
  }
  checkToken();
  useEffect(() => {
    // This will run only once on component mount
  }, []);
  console.log('VITE_URL:', import.meta.env.VITE_URL); // prints the URL
  console.log('VITE_DEBUG:', import.meta.env.VITE_DEBUG); // prints 'true' or 'false'
  //console.log('sso url:', import.meta.env.VITE_URL); // prints the URL
  //console.log('sso client id :', import.meta.env.VITE_SSO_CLIENT_ID);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("")
  const handleLogin = (e) => {
    e.preventDefault();
    console.log('login clicked');
    //window.location.href = '/clientDetails';
    // prints 'true' or 'false'

    console.log(`${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`)
    window.location.href = `${import.meta.env.VITE_SSO_URL}?clientId=${import.meta.env.VITE_SSO_CLIENT_ID}`;
    // let loginBtn = document.querySelector('#login-btn');
    // loginBtn.addEventListener('click', (e)=>{

    //   console.log('clicked');
    // })
    //handleLogin();
    // useEffect(()=>{
    //    handleLogin()
    // },[])
    //window.location.href = '/clientDetails';
    // const user = {
    //     email:email,
    //     password:password
    // }
    // console.log({user});
  }

  return (
    <>

      {/* <div className={styles.main}>
        <div className={styles.loginGroup}>
          <p className={styles.heading}>Login</p>
          <form className={styles.formGroup}>
            <label className={styles.formLabel} htmlFor="bCode">Business Code/ Email
          <input className={styles.formInput} type="text" id='bCode' name='bCode' value={email} onChange={(e)=>setEmail(e.target.value)} placeholder='Enter your business code or email' />
          </label>
          <label className={styles.formLabel} htmlFor="password">Password
          <input className={styles.formInput} type="password" id='password' name='password' value={password} onChange={(e)=>setPassword(e.target.value)} placeholder='Enter your password' />
          </label><div className={styles.forgotPassword}>
            <p>Forgot Password?</p>
          </div>
            <div>
              <button id='login-btn' onClick={handleLogin} className={styles.formLogin}>Login</button>
            </div>

          </form>
          <div className={styles.bottomLine}>
            <p>To log trouble ticket <span className={styles.help}><a>Click Here</a></span></p>
          </div>
        </div>
      </div> */}
    </>
  )
}

export default LoginPage